import React from 'react';
import ReactDOM from 'react-dom';
import './public/utils';
import Home from 'pages/home';

if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(<Home />, document.getElementById("root"));

document.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});

const loadAsyncScript = (url, id) => {
  if (!url) { return; }
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  if (id) { script.id = id; }
  script.async = true;
  document.head.appendChild(script);
};

const loadAsyncCss = (url, id) => {
  if (!url) { return; }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  if (id) { link.id = id; }
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
};

let _deferredLoaded = false;
const loadDeferredResources = () => {

  if (_deferredLoaded) { return; }
  _deferredLoaded = true;
  const run = () => {
    loadAsyncCss(window.TINPER_CSS_URL, 'tinper-next-css-id');
    loadAsyncScript(window.TINPER_JS_URL, 'tinper-next-js-id');
    if (window._PRELOAD_URL_) {
      loadAsyncScript(window._PRELOAD_URL_);
    }
  };
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(run);
  } else {
    setTimeout(run, 300);
  }
};

window.__loadDeferredResources__ = loadDeferredResources;
